import type { ComponentType } from "react";

import { CrmEnrichmentProvider } from "app/pages/sales-intelligence/modules/crm-enrichment/contexts/CrmEnrichmentContext";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import type { UnknownProps } from "app/pages/sales-intelligence/types";

const withCrmEnrichmentProvider = <P extends UnknownProps>(Component: ComponentType<P>) => {
    return function WrappedWithCrmEnrichmentProvider(props: P) {
        const { integrationName } = getIntegrationNameFromUrl();

        return (
            <CrmEnrichmentProvider crmProvider={integrationName as Integration}>
                <Component {...props} />
            </CrmEnrichmentProvider>
        );
    };
};

export default withCrmEnrichmentProvider;
